import { TeamsSubscriptionPlans, TeamsSubscriptionScopes } from "@teams/types";

export function getPlanLabel(
  plan: TeamsSubscriptionPlans,
  planLevel?: number,
  subscriptionScope?: TeamsSubscriptionScopes
): "Pro" | "Standard" | "Standup" | "Enterprise" {
  switch (plan) {
    case "agile-standup":
      return "Standup";
    case "msteams-standard":
      if (subscriptionScope === "tenant") {
        return "Enterprise";
      } else if (planLevel && planLevel >= 2500) {
        return "Pro";
      } else return "Standard";
    default:
      return "Standard";
  }
}
